import CryptoJS from 'crypto-js';

const generateImageHash = (string) => {
  let sha1 = CryptoJS.HmacSHA1(string, '624eK4R36tdZt823ZI411757F0Ej4JHlwl0691Dp');
  return CryptoJS.enc.Hex.stringify(sha1);
};

export const generateImageUrl = ({ size, type = 'png', quality = '80', imageUrl } = {}) => {
  var generatedHash = generateImageHash(size + '-' + type + '-' + quality + '-' + imageUrl);
  var url =
    'https://diodynamicimage.oned.io/fit-in/' +
    size +
    '/filters:format(' +
    type +
    ')/filters:quality(' +
    quality +
    ')/' +
    generatedHash +
    '/' +
    imageUrl;
  return url;
};
